import { render } from "./changePhone.vue?vue&type=template&id=b5e83916&scoped=true"
import script from "./changePhone.vue?vue&type=script&lang=js"
export * from "./changePhone.vue?vue&type=script&lang=js"

import "./changePhone.vue?vue&type=style&index=0&id=b5e83916&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e83916"]])

export default __exports__